import {Component} from '@angular/core';

@Component({
  template: `<h1 class="text-center text-danger">Error, close this page and retry again!</h1>`
})

export class RedirectionFailureComponent {

}
